import { render, staticRenderFns } from "./right-nav.vue?vue&type=template&id=c0cf5464&scoped=true&"
import script from "./right-nav.vue?vue&type=script&lang=js&"
export * from "./right-nav.vue?vue&type=script&lang=js&"
import style0 from "./right-nav.vue?vue&type=style&index=0&id=c0cf5464&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cf5464",
  null
  
)

export default component.exports